<template>
  <div v-if="sortedUserBadges.length > 0" class="user-badges-section">
    <div class="t-lg bold gray m-bx2 f f-ac f-gap-4">
      Donut badges
      <i class="mi md-16 gray cursor-pointer" title="Learn more about Donut badges" @click="openInfoModal">info</i>
    </div>
    <div class="badges-container f f-wrap f-gap-8">
      <user-profiles-badge
        v-for="userBadge in sortedUserBadges"
        :id="userBadge.badge.id"
        :key="userBadge.id"
        :product="userBadge.badge.product"
        :name="userBadge.badge.name"
        :emoji="userBadge.badge.emoji"
        :description="userBadge.badge.description"
        :earned-at="userBadge.earned_at"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  userBadges: {
    type: Array,
    required: true,
    default: () => [],
  },
  allBadges: {
    type: Array,
    required: true,
    default: () => [],
  },
});

const { commit } = useStore();

const sortedUserBadges = computed(() => [...props.userBadges].sort((a, b) => {
    // Sort by earned_at date, most recent first
    const dateA = new Date(a.earned_at);
    const dateB = new Date(b.earned_at);
    return dateB - dateA;
  }));

const openInfoModal = () => {
  commit('updateModal', {
    visible: true,
    size: 'lg',
    subcomponent: 'user-profiles-modals-achievements-info',
    dismissable: true,
    data: {
      badges: props.allBadges,
    },
  });
};
</script>

<style scoped lang="scss">
.user-badges-section {
  width: 100%;
}

.badges-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.cursor-pointer {
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }
}
</style>
